import { render, staticRenderFns } from "./CommonAppWarning.vue?vue&type=template&id=9f6dfc96&"
import script from "./CommonAppWarning.vue?vue&type=script&lang=ts&"
export * from "./CommonAppWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports